import React, {Component} from 'react'
import {keys} from "../Constants"
import {acu_data} from "../data/Data"
import {reactLocalStorage} from 'reactjs-localstorage';
//import ToggleButton from 'react-bootstrap/ToggleButton';
//import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import Select from 'react-select'
import PainPointsTable from './PointsTable/PainPointsTable'
import Cards from "../Cards/Cards";
import './PainTable.css';
import '../Client.css';
import '../Cards/Cards.css';

class PainTable extends Component {
    constructor(props) {
        super(props);

        this.saveData = this.saveData.bind(this);
        this.getPoints = this.getPoints.bind(this);
        this.getXues = this.getXues.bind(this);
        this.getBodyParts = this.getBodyParts.bind(this);
        this.bodyPartsChange = this.bodyPartsChange.bind(this);
        this.getPointById = this.getPointById.bind(this);
        this.getPointGroup = this.getPointGroup.bind(this);
        this.getPointCombinations = this.getPointCombinations.bind(this);
        this.toggleCards = this.toggleCards.bind(this);

        this.state = {
            ready: false,
            table: [],
            filters: [],
            channels: [],
            configuration: [],
            currentBodyParts: "",
            showPointCards: true,
        }
    }

    saveData() {
        reactLocalStorage.set(keys.bodyPartsResult2.value, this.state.currentBodyParts);
    }

    componentDidMount() {
        let bodyPartsValue = reactLocalStorage.get(keys.bodyPartsResult2.value, "");

        let tempData = this.state.channels;
        tempData = tempData.concat(acu_data.lu);
        tempData = tempData.concat(acu_data.li);
        tempData = tempData.concat(acu_data.st);
        tempData = tempData.concat(acu_data.sp);
        tempData = tempData.concat(acu_data.ht);
        tempData = tempData.concat(acu_data.si);
        tempData = tempData.concat(acu_data.bl);
        tempData = tempData.concat(acu_data.ki);
        tempData = tempData.concat(acu_data.pc);
        tempData = tempData.concat(acu_data.te);
        tempData = tempData.concat(acu_data.gb);
        tempData = tempData.concat(acu_data.lr);
        tempData = tempData.concat(acu_data.cv);
        tempData = tempData.concat(acu_data.gv);
        tempData = tempData.concat(acu_data.extra);

        let taoTable = acu_data.pain;

        let configuration = acu_data.configuration;

        this.setState({
            channels: tempData,
            table: taoTable,
            configuration: configuration,
            currentBodyParts: bodyPartsValue,
            ready: true
        });
    }

    bodyPartsChange(e) {
        let current = "";
        if (e !== null) {
            for (let id in e) {
                if (current.length > 0)
                    current += ",";
                current += e[id]["value"];
            }
        }

        let that = this;
        this.setState({
            currentBodyParts: current
        }, () => {
            that.saveData();
        });
    }

    toggleCards() {
        this.setState({
            showPointCards: !this.state.showPointCards
        });
    }

    getBodyParts() {
        let bodyParts = this.state.table;
        return bodyParts.map(item => {
            let name = item[keys.name.value]
                .replace(/\s*\(.*?\)\s*/g, "")
                .trim();
            let id = item[keys.id.value];
            return {value: id, label: name};
        });
    }

    getPointById(pointId) {
        let id = pointId.trim();
        let foundPoint = null;

        this.state.channels.forEach(channel => {
            if (foundPoint !== null) return;

            let allxue = channel[keys.allxue.value].split(",");
            if (allxue.indexOf(id) === -1) return;

            let points = channel[keys.xues.value];
            let foundItems = points.filter(_point => {
                return (_point[keys.id.value] === id)
            });

            if (foundItems.length > 0) {
                foundPoint = Object.assign({}, foundItems[0], {
                    channel: channel[keys.short.value]
                });
            }
        });

        return foundPoint;
    }

    getPointGroup(pointIds) {
        return pointIds
            .split(",")
            .map(id => this.getPointById(id))
            .filter(point => point !== null);
    }

    getPointCombinations(item, fieldName) {
        if (!item.pointGroups || !item.pointGroups[fieldName]) return null;

        return item.pointGroups[fieldName].map(group => {
            return {
                label: group.label,
                description: group.description,
                points: group.points
                    .map(id => this.getPointById(id))
                    .filter(point => point !== null)
            }
        }).filter(group => group.points.length > 0);
    }

    getPoints(bodyPart) {
        if (bodyPart === "")
            return <div/>;

        let table = this.state.table;

        //organ
        let pointsTable = [];
        let points = [];
        let i = 0;
        let selectedBodyParts = bodyPart.split(",");
        table.forEach(item => {
            if (selectedBodyParts.indexOf(item[keys.id.value]) === -1) return;

            points.push(
                {
                    name: item[keys.name.value],
                    mainPoints: this.getPointGroup(item[keys.mainPoints.value]),
                    additionalPoints: this.getPointGroup(item[keys.additionalPoints.value]),
                    electroPoints: this.getPointGroup(item[keys.electroPoints.value]),
                    mainPointGroups: this.getPointCombinations(item, keys.mainPoints.value),
                    additionalPointGroups: this.getPointCombinations(item, keys.additionalPoints.value),
                    electroPointGroups: this.getPointCombinations(item, keys.electroPoints.value),
                }
            );

        });

        pointsTable.push(
            <PainPointsTable
                key={i++}
                table={points}
            />
        );

        return pointsTable;
    }

    getXues(bodyPart) {
        if (bodyPart === "")
            return "";

        let table = this.state.table;

        let xues = "";
        //body parts
        //let bodyItems = bodyPart.split(",");
        table.forEach(item => {
            if (!bodyPart.match(item[keys.id.value])) return;

            let mainPoints = item[keys.mainPoints.value].split(",");
            let additionalPoints = item[keys.additionalPoints.value].split(",");
            let electroPoints = item[keys.electroPoints.value].split(",");

            this.state.channels.forEach(channel => {
                let allxue = channel[keys.allxue.value].split(",");
                //main points
                mainPoints.forEach(id => {
                    allxue.forEach(xueId => {
                        if (xueId.trim() === id) {
                            let points = channel[keys.xues.value];
                            let foundItem = points.filter(_point => {
                                return (_point[keys.id.value] === id)
                            });
                            if (xues.length > 0)
                                xues += ", ";
                            xues += foundItem[0][keys.id.value]//.push(foundItem[0][keys.name.value]);
                        }
                    });
                });
                //additional points
                additionalPoints.forEach(id => {
                    allxue.forEach(xueId => {
                        if (xueId.trim() === id) {
                            let points = channel[keys.xues.value];
                            let foundItem = points.filter(_point => {
                                return (_point[keys.id.value] === id)
                            });
                            if (xues.length > 0)
                                xues += ", ";
                            xues += foundItem[0][keys.id.value];//;.push(foundItem[0][keys.name.value]);
                        }
                    });
                });
                //additional points
                electroPoints.forEach(id => {
                    allxue.forEach(xueId => {
                        if (xueId.trim() === id) {
                            let points = channel[keys.xues.value];
                            let foundItem = points.filter(_point => {
                                return (_point[keys.id.value] === id)
                            });
                            if (xues.length > 0)
                                xues += ", ";
                            xues += foundItem[0][keys.id.value];//;.push(foundItem[0][keys.name.value]);
                        }
                    });
                });
            });
        });

        return xues;
    }

    render() {
        if (!this.state.ready) return <div/>;

        let heading = "Akupunkturní protokoly pro úlevy od bolesti";
//        let heading2 = "Použití";

        let currentChannel = "";
        let channels = this.state.configuration["channels"];
        for (let _item in channels) {
            if (channels[_item]["channel"] === "") continue;
            currentChannel += channels[_item]["channel"] + ",";
        }

        //body parts
        const bodyPartsOptions = this.getBodyParts();
        if (bodyPartsOptions.length === 0)
            return (<div/>);

        let bodyPartsDefaultvalue = null;
        let currentBP = this.state.currentBodyParts;

        if (currentBP !== "") {
            bodyPartsDefaultvalue = bodyPartsOptions.filter(option => {
                return (currentBP.indexOf(option.value) !== -1);
            });
        }

        let points = this.getPoints(currentBP);
        let xues = this.getXues(currentBP);
        let filters = this.state.filters;
        filters[keys.bagangxue.value] = xues;
        return (
            <div id="tcme">
                <div className="channel-heading channel-heading-top normal-color">{heading}</div>
                <div className="leung-basic-single">
                    <div className="pain-card-toolbar">
                        <label className="pain-card-toggle">
                            <input
                                type="checkbox"
                                checked={this.state.showPointCards}
                                onChange={this.toggleCards}
                            />
                            <span>Zobrazit karty bodů</span>
                        </label>
                    </div>
                </div>
                <div className="leung-basic-single">
                    <Select
                        className="acu-basic-single-top-p"
                        classNamePrefix="select"
                        name="bodyPart-selector"
                        isMulti={true}
                        defaultValue={bodyPartsDefaultvalue}
                        isSearchable={false}
                        options={bodyPartsOptions}
                        onChange={this.bodyPartsChange}
                    />
                </div>
                <div className="leung-basic-single">
                    {points}
                </div>
                {this.state.showPointCards &&
                    <div className="leung-basic-single">
                        <Cards
                            currentChannel={currentChannel}
                            filters={filters}
                            showInfoForm={this.showInfoForm}
                        />
                    </div>
                }
            </div>
        )
    }
}

export default PainTable
